import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
// import Checkbox from '@material-ui/core/Checkbox';
// import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { withStyles } from '@material-ui/core/styles';

// import EmptyWidget from './EmptyWidget';
import JumpInWidget from './JumpInWidget';
import JumpInActionsWidget from './JumpInActionsWidget';
// import GettingStartedWidget from './GettingStartedWidget';
import GettingStartedActionsWidget from './GettingStartedActionsWidget';
import FeatureSpotlightWidget from './FeatureSpotlightWidget';
import UpcomingEventsWidget from './UpcomingEventsWidget';
import ResourcesWidget from './ResourcesWidget';
// import CaptureWidget from './CaptureWidget';
// import DocumentsWidget from './DocumentsWidget';
import RecentlyAccessedDocumentsWidget from './RecentlyAccessedDocumentsWidget';
import ProjectsWidget from './ProjectsWidget';
import TaskSchedulesWidget from './TaskSchedulesWidget';
import TaskCompletionsWidget from './TaskCompletionsWidget';
import FormSubmissionsWidget from './FormSubmissionsWidget';
import SignatureCompletionsWidget from './SignatureCompletionsWidget';
import SignatureSessionsWidget from './SignatureSessionsWidget';
// import FolderWidget from './FolderWidget';
// import ApprovalsWidget from './ApprovalsWidget';
// import SubscriptionsWidget from './SubscriptionsWidget';
// import TasksWidget from './TasksWidget';
// import NeedSignatureWidget from './NeedSignatureWidget';
// import PowerSearchWidget from './PowerSearchWidget';

// import Tree from '../Tree';

import DashboardWidget from '../../Model/DashboardWidget';

import API, {
  GetOrganizationDashboardWidgetsPathForApi,
} from '../../Util/api';
import ProgressIndicator from '../ProgressIndicator';
import MultiUseDialog from '../MultiUseDialog';
import { GetProjectFoldersPath } from '../../Util/PathHelper';
import {
  HandleSetShowProjectSelectionDialog,
  GetProjectSelectionDialog,
} from '../../Util/Projects';
// import PowerSearchControls from '../PowerSearchControls';
import { GlobalContext } from '../../Context/Global.context';
import { GetFolderHierarchies } from '../../Util/Nodes';
import { IsMobile } from '../../Util/MobileDetector';

const styles = theme => ({
  content: {
    backgroundColor:theme.palette.background.default,
  },
  contentGrid: {
  },
  gridItem: {
    cursor:"pointer",
    // Necessary for overlay
    position:"relative",
  },
  dialogPaper: {
    minHeight:300,
  }
  // checkbox: {
  //   position:"absolute",
  //   top:theme.spacing(2),
  //   right:theme.spacing(2),
  //   fontSize:52,
  //   pointerEvents:"none",
  // }
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class AddDashboardWidgetDialog extends Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);
    
    this.state = {
      open: props.open,
      SelectedWidgetType: "",
      DialogDetails: { Open: false },
      SelectedNode: null,
      WidgetProjectMember: null,
      ShowProjectSelectionDialog: false,
      SelectedNodeUnhighlightFunction: null,
      ShowProgressIndicator: false,
      ShowProgressIndicatorImmediately: false,
    }

    this.NodeHighlightFunctionsByNodeUniqueId = {};
    this.getSearchQueryAndNameAndDetailFunction = null;
  }

  handleClose = () => {
    this.setState({ 
      open: false,
      ShowProgressIndicator: false,
      ShowProgressIndicatorImmediately: false,
     });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  handleNavigateToSearch() {
    this.props.history.push("/search");
  }

  handleNavigateToFolders() {
    this.props.history.push(GetProjectFoldersPath());
  }

  handleAddDashboardWidget(dashboardWidget) {
    if (!dashboardWidget) {
      return;
    }

    // Verify project admin for some widgets
    switch (dashboardWidget.Type) {
      case "TaskSchedules":
      case "TaskCompletions":
      case "FormSubmissions":
      case "SignatureCompletions":
      case "SignatureSessions":
        if (!this.isProjectAdmin(dashboardWidget.ProjectID)) {
          return this.handleApiError(`You must be a manager of this project to use this widget.`)
        }
        break;
      default:
        break;
    }

    this.setState({ShowProgressIndicatorImmediately:true});
    API.post(GetOrganizationDashboardWidgetsPathForApi(
      this.props.organizationId), [dashboardWidget])
    .then(resp => {
      this.handleClose();
    })
    .catch(this.handleApiError);
  }

  handleSelectWidget(widget) {
    switch (widget.Type) {
      case "Folder":
      case "PowerSearch":
      case "Documents":
      case "TaskSchedules":
      case "TaskCompletions":
      case "FormSubmissions":
      case "SignatureCompletions":
      case "SignatureSessions":
      this.handleSetDialogVisibility(widget.Type, true);
      break;
      default:
      let dashboardWidget = {...DashboardWidget};
      dashboardWidget.Type = widget.Type;
      this.handleAddDashboardWidget(dashboardWidget);
      break;
    }
  }

  getFolderHierarchies() {
    this.setState({ ShowProgressIndicatorImmediately: true });
    return GetFolderHierarchies(() => this.setState({ShowProgressIndicatorImmediately:false}), this.handleApiError);
  }

  handleSetNodeHighlightFunction = (uniqueId, highlightFunction) => {
    this.NodeHighlightFunctionsByNodeUniqueId[uniqueId] = highlightFunction;
  }

  handleSetNodeUnhighlightFunction = unhighlightFunction => {
    this.setState({ SelectedNodeUnhighlightFunction: unhighlightFunction });
  }

  handleNodeSelect = node => {
    if (this.state.SelectedNodeUnhighlightFunction) {
      this.state.SelectedNodeUnhighlightFunction();
    }
    this.setState({ SelectedNode: node });
  }

  handleConnectGetSearchQueryAndNameAndDetailFunction = f => {
    this.getSearchQueryAndNameAndDetailFunction = f; 
  }

  handleSetDialogVisibility(SelectedWidgetType, visible) {
    if (!visible) {
      this.setState({DialogDetails: { Open: false }});
      return;
    }
    if (!SelectedWidgetType) {
      return;
    }

    switch (SelectedWidgetType) {
      case "Documents":
      case "TaskSchedules":
      case "TaskCompletions":
      case "FormSubmissions":
      case "SignatureCompletions":
      case "SignatureSessions":
        this.setState({SelectedWidgetType});
        HandleSetShowProjectSelectionDialog(state => this.setState(state), true);
        break;
      // case "Folder":
      //   this.getFolderHierarchies()
      //     .then(folderHierarchies => {
      //       const confirmCallback = () => {
      //         if (!this.state.SelectedNode) {
      //           return;
      //         }
      //         this.handleSetDialogVisibility(null, false);
      //         this.setState({ShowDialogProgressIndicator:true});
      //         let dashboardWidget = {...DashboardWidget};
      //         dashboardWidget.Name = this.state.SelectedNode.Name;
      //         dashboardWidget.Type = "Folder";
      //         dashboardWidget.JsonData = JSON.stringify(this.state.SelectedNode);
      //         this.handleAddDashboardWidget(dashboardWidget);
      //       };
      //       const dialogDetails = {
      //         Open: new Date(),
      //         Title: "Folder Widget",
      //         BodyContent: (
      //           <Tree
      //             folderHierarchies={folderHierarchies}
      //             onSetNodeHighlightFunction={this.handleSetNodeHighlightFunction}
      //             onSetNodeUnhighlightFunction={this.handleSetNodeUnhighlightFunction}
      //             onNodeSelect={this.handleNodeSelect}
      //             onApiError={this.handleApiError}
      //           />
      //         ),
      //         IsConfirmation: true,
      //         ConfirmLabel: "ADD",
      //         ConfirmCallback: confirmCallback,
      //       };
      //       this.setState({DialogDetails: dialogDetails, FolderHierarchies: folderHierarchies});
      //     });
      //   break;
      // case "PowerSearch":
      //   let confirmCallback = () => {
      //     const queryAndNameAndDetail = this.getSearchQueryAndNameAndDetailFunction();
      //     if (!queryAndNameAndDetail.Name) {
      //       return;
      //     }
      //     this.handleSetDialogVisibility(null, false);
      //     this.setState({ShowDialogProgressIndicator:true});
      //     let dashboardWidget = {...DashboardWidget};
      //     dashboardWidget.Name = queryAndNameAndDetail.Name;
      //     dashboardWidget.Detail = queryAndNameAndDetail.Detail;
      //     dashboardWidget.Type = "PowerSearch";
      //     dashboardWidget.JsonData = JSON.stringify(queryAndNameAndDetail.SearchQuery);
      //     this.handleAddDashboardWidget(dashboardWidget);
      //   };
      //   const dialogDetails = {
      //     Open: new Date(),
      //     Title: "Search Widget",
      //     DialogWidth: "xl",
      //     BodyClassName: "scrollFix",
      //     BodyContent: (
      //       <PowerSearchControls
      //         onConnectgetSearchQueryAndNameAndDetailFunction={this.handleConnectGetSearchQueryAndNameAndDetailFunction}
      //         onShowProgressIndicator={this.handleShowProgressIndicator}
      //         onApiError={this.handleApiError}
      //         onAlert={this.handleAlert}
      //         isDashboardWidgetCreation
      //       />
      //     ),
      //     IsConfirmation: true,
      //     ConfirmLabel: "ADD",
      //     ConfirmCallback: confirmCallback,
      //   };
      //   this.setState({DialogDetails: dialogDetails});
      //   break;
      default:
        break;
    }
  }

  isProjectAdmin = projectId => {
    const projectMemberPkgFinder = this.context.ProjectMembershipPackages
      .filter(p => p.Project.ID === projectId);
    const isProjectMember = projectMemberPkgFinder.length > 0;
    const isProjectAdmin = isProjectMember && projectMemberPkgFinder[0].ProjectMember.IsAdmin;
    return isProjectAdmin;
  }

  handleApiError = err => {
    this.setState({
      ShowProgressIndicator: false,
      ShowProgressIndicatorImmediately: false,
    });
    this.props.onApiError(err);
  }

  handleAlert = alertDetails => {
    this.setState({Alert: alertDetails});
  }

  handleShowProgressIndicator = show => {
    this.setState({
      ShowProgressIndicator: show,
    });
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    if (typeof this.props.open !== "undefined"
      && prevProps.open !== this.props.open) {
      this.setState({
        open: this.props.open !== false, 
        ShowProgressIndicator: false,
        SelectedWidgetType: "", 
        DialogDetails: { Open: false },
      });
    }
  }

  render() {
    const {
      open,
      DialogDetails,
      SelectedWidgetType,
      ShowProjectSelectionDialog,
      ShowProgressIndicator,
      ShowProgressIndicatorImmediately,
    } = this.state;
    const {
      classes,
      // theme,
      activeDashboardWidgets,
      organizationId,
    } = this.props;
    // const {
    //   // ActiveOrganizationPermissions,
    //   ProjectMembershipPackages,
    // } = this.context;

    let progressIndicator = null;
    if (ShowProgressIndicator || ShowProgressIndicatorImmediately) {
      progressIndicator = (
        <ProgressIndicator showImmediately={ShowProgressIndicatorImmediately} />
      );
    }

    let dialogActions = (
      <DialogActions className={classes.content}>
        <Button onClick={this.handleClose}>
          CLOSE
        </Button>
        {/* {addButton} */}
        {/* {learnButton} */}
      </DialogActions>
    );

    const getCoreWidgetProps = () => { return {
      DashboardWidget: {},
      organizationId,
      history: this.props.history,
      location: this.props.location,
      xl: 12,
      lg: 12,
      md: 12,
      sm: 12,
      xs: 12,
      noPointerEvents: true,
      noMargin: true,
      isSample: true,
      onApiError: err => this.handleApiError(err),
      onAlert: details => this.handleAlert(details),
    }};

    let widgets = [
      // {
      //   Type: "Empty",
      //   Content: (
      //     <EmptyWidget
      //       {...getCoreWidgetProps()}
      //     />
      //   )
      // },
    ];
    if (activeDashboardWidgets.filter(w => w.Type === "JumpIn").length === 0) {
      widgets.push(
        {
          Type: "JumpIn",
          Content: (
            <JumpInWidget
              {...getCoreWidgetProps()}
            />
          )
        },
      );
    }
    if (activeDashboardWidgets.filter(w => w.Type === "JumpInActions").length === 0) {
      widgets.push(
        {
          Type: "JumpInActions",
          Content: (
            <JumpInActionsWidget
              {...getCoreWidgetProps()}
            />
          )
        },
      );
    }
    // if (activeDashboardWidgets.filter(w => w.Type === "GettingStarted").length === 0) {
    //   widgets.push(
    //     {
    //       Type: "GettingStarted",
    //       Content: (
    //         <GettingStartedWidget
    //           {...getCoreWidgetProps()}
    //         />
    //       )
    //     },
    //   );
    // }
    if (activeDashboardWidgets.filter(w => w.Type === "GettingStartedActions").length === 0) {
      widgets.push(
        {
          Type: "GettingStartedActions",
          Content: (
            <GettingStartedActionsWidget
              {...getCoreWidgetProps()}
            />
          )
        },
      );
    }
    if (activeDashboardWidgets.filter(w => w.Type === "FeatureSpotlight").length === 0) {
      widgets.push(
        {
          Type: "FeatureSpotlight",
          Content: (
            <FeatureSpotlightWidget
              {...getCoreWidgetProps()}
            />
          )
        },
      );
    }
    if (activeDashboardWidgets.filter(w => w.Type === "UpcomingEvents").length === 0) {
      widgets.push(
        {
          Type: "UpcomingEvents",
          Content: (
            <UpcomingEventsWidget
              {...getCoreWidgetProps()}
            />
          )
        },
      );
    }
    if (activeDashboardWidgets.filter(w => w.Type === "Resources").length === 0) {
      widgets.push(
        {
          Type: "Resources",
          Content: (
            <ResourcesWidget
              {...getCoreWidgetProps()}
            />
          )
        },
      );
    }
    if (activeDashboardWidgets.filter(w => w.Type === "Projects").length === 0) {
      widgets.push(
        {
          Type: "Projects",
          Content: (
            <ProjectsWidget
              {...getCoreWidgetProps()}
            />
          )
        },
      );
    }
    const sampleDateBase = new Date();
    if (activeDashboardWidgets.filter(w => w.Type === "RecentlyAccessedDocuments").length === 0) {
      widgets.push(
        {
          Type: "RecentlyAccessedDocuments",
          Content: (
            <RecentlyAccessedDocumentsWidget
              {...getCoreWidgetProps()}
              samples={[
                { DocumentID: 1, DocumentName: "Expense Report - June.xls", AccessedOn: sampleDateBase-(1*86400000), },
                { DocumentID: 2, DocumentName: "Meeting Notes.txt", AccessedOn: sampleDateBase-(2*86400000), },
                { DocumentID: 3, DocumentName: "Employee Handbook.pdf", AccessedOn: sampleDateBase-(3*86400000), },
                { DocumentID: 4, DocumentName: "Quarterly Report.pdf", AccessedOn: sampleDateBase-(3*86400000), },
                { DocumentID: 5, DocumentName: "July - Inventory.pdf", AccessedOn: sampleDateBase-(3*86400000), },
                { DocumentID: 6, DocumentName: "June - Inventory.pdf", AccessedOn: sampleDateBase-(4*86400000), },
              ]}
            />
          )
        },
      );
    }
    widgets.push(
      {
        Type: "TaskSchedules",
        Content: (
          <TaskSchedulesWidget
            {...getCoreWidgetProps()}
            samples={[
              { OnTime: 10, Unscheduled: 15, PastDue: 8, CreatedOn: sampleDateBase-(8*14400000), },
              { OnTime: 11, Unscheduled: 14, PastDue: 8, CreatedOn: sampleDateBase-(7*14400000), },
              { OnTime: 11, Unscheduled: 14, PastDue: 8, CreatedOn: sampleDateBase-(6*14400000), },
              { OnTime: 11, Unscheduled: 14, PastDue: 8, CreatedOn: sampleDateBase-(5*14400000), },
              { OnTime: 9, Unscheduled: 14, PastDue: 10, CreatedOn: sampleDateBase-(4*14400000), },
              { OnTime: 8, Unscheduled: 14, PastDue: 11, CreatedOn: sampleDateBase-(3*14400000), },
              { OnTime: 6, Unscheduled: 14, PastDue: 13, CreatedOn: sampleDateBase-(2*14400000), },
              { OnTime: 6, Unscheduled: 14, PastDue: 13, CreatedOn: sampleDateBase-(1*14400000), },
            ]}
          />
        )
      },
    );
    widgets.push(
      {
        Type: "TaskCompletions",
        Content: (
          <TaskCompletionsWidget
            {...getCoreWidgetProps()}
            samples={[{"ID":"20230202","Date":"2023-02-02T00:00:00Z","UTCn12":2,"UTCn11":2,"UTCn10":2,"UTCn9":2,"UTCn8":2,"UTCn7":2,"UTCn6":2,"UTCn5":3,"UTCn4":3,"UTCn3":3,"UTCn2":3,"UTCn1":3,"UTC":3,"UTCp1":3,"UTCp2":3,"UTCp3":3,"UTCp4":3,"UTCp5":3,"UTCp6":3,"UTCp7":2,"UTCp8":2,"UTCp9":2,"UTCp10":2,"UTCp11":2,"UTCp12":2},{"ID":"20230201","Date":"2023-02-01T00:00:00Z","UTCn12":2,"UTCn11":2,"UTCn10":2,"UTCn9":2,"UTCn8":2,"UTCn7":2,"UTCn6":2,"UTCn5":1,"UTCn4":1,"UTCn3":1,"UTCn2":1,"UTCn1":1,"UTC":1,"UTCp1":1,"UTCp2":1,"UTCp3":2,"UTCp4":2,"UTCp5":3,"UTCp6":3,"UTCp7":6,"UTCp8":6,"UTCp9":6,"UTCp10":6,"UTCp11":6,"UTCp12":6},{"ID":"20230131","Date":"2023-01-31T00:00:00Z","UTCn12":6,"UTCn11":6,"UTCn10":6,"UTCn9":6,"UTCn8":6,"UTCn7":6,"UTCn6":6,"UTCn5":6,"UTCn4":6,"UTCn3":6,"UTCn2":6,"UTCn1":6,"UTC":6,"UTCp1":6,"UTCp2":6,"UTCp3":5,"UTCp4":5,"UTCp5":4,"UTCp6":4,"UTCp7":0,"UTCp8":0,"UTCp9":0,"UTCp10":0,"UTCp11":0,"UTCp12":0},{"ID":"20230130","Date":"2023-01-30T00:00:00Z","UTCn12":0,"UTCn11":0,"UTCn10":0,"UTCn9":0,"UTCn8":0,"UTCn7":0,"UTCn6":0,"UTCn5":0,"UTCn4":0,"UTCn3":0,"UTCn2":0,"UTCn1":0,"UTC":0,"UTCp1":0,"UTCp2":1,"UTCp3":1,"UTCp4":1,"UTCp5":1,"UTCp6":1,"UTCp7":1,"UTCp8":1,"UTCp9":2,"UTCp10":2,"UTCp11":2,"UTCp12":2},{"ID":"20230129","Date":"2023-01-29T00:00:00Z","UTCn12":2,"UTCn11":2,"UTCn10":2,"UTCn9":2,"UTCn8":2,"UTCn7":2,"UTCn6":2,"UTCn5":2,"UTCn4":2,"UTCn3":2,"UTCn2":2,"UTCn1":2,"UTC":2,"UTCp1":2,"UTCp2":2,"UTCp3":2,"UTCp4":2,"UTCp5":2,"UTCp6":2,"UTCp7":2,"UTCp8":2,"UTCp9":1,"UTCp10":1,"UTCp11":1,"UTCp12":1},{"ID":"20230128","Date":"2023-01-28T00:00:00Z","UTCn12":1,"UTCn11":1,"UTCn10":1,"UTCn9":1,"UTCn8":1,"UTCn7":1,"UTCn6":1,"UTCn5":1,"UTCn4":1,"UTCn3":1,"UTCn2":1,"UTCn1":1,"UTC":1,"UTCp1":1,"UTCp2":2,"UTCp3":2,"UTCp4":2,"UTCp5":2,"UTCp6":2,"UTCp7":2,"UTCp8":2,"UTCp9":2,"UTCp10":2,"UTCp11":2,"UTCp12":2},{"ID":"20230127","Date":"2023-01-27T00:00:00Z","UTCn12":2,"UTCn11":2,"UTCn10":2,"UTCn9":2,"UTCn8":2,"UTCn7":2,"UTCn6":2,"UTCn5":2,"UTCn4":2,"UTCn3":2,"UTCn2":2,"UTCn1":2,"UTC":2,"UTCp1":2,"UTCp2":0,"UTCp3":2,"UTCp4":2,"UTCp5":2,"UTCp6":2,"UTCp7":2,"UTCp8":2,"UTCp9":3,"UTCp10":3,"UTCp11":3,"UTCp12":3}]}
          />
        )
      },
    );
    widgets.push(
      {
        Type: "FormSubmissions",
        Content: (
          <FormSubmissionsWidget
            {...getCoreWidgetProps()}
            samples={[{"ID":"20230206","CreatedOn":"2023-02-06T16:34:40.50464Z","Date":"2023-02-06T00:00:00Z","UTCn12":2,"UTCn11":2,"UTCn10":2,"UTCn9":2,"UTCn8":2,"UTCn7":2,"UTCn6":2,"UTCn5":2,"UTCn4":2,"UTCn3":2,"UTCn2":2,"UTCn1":2,"UTC":2,"UTCp1":2,"UTCp2":2,"UTCp3":3,"UTCp4":3,"UTCp5":3,"UTCp6":3,"UTCp7":3,"UTCp8":1,"UTCp9":1,"UTCp10":1,"UTCp11":1,"UTCp12":1},{"ID":"20230205","CreatedOn":"2023-02-06T16:34:36.29467Z","Date":"2023-02-05T00:00:00Z","UTCn12":1,"UTCn11":1,"UTCn10":1,"UTCn9":1,"UTCn8":1,"UTCn7":1,"UTCn6":1,"UTCn5":2,"UTCn4":2,"UTCn3":2,"UTCn2":2,"UTCn1":2,"UTC":2,"UTCp1":2,"UTCp2":2,"UTCp3":2,"UTCp4":2,"UTCp5":2,"UTCp6":2,"UTCp7":2,"UTCp8":2,"UTCp9":2,"UTCp10":2,"UTCp11":2,"UTCp12":2},{"ID":"20230204","CreatedOn":"2023-02-06T16:34:32.212058Z","Date":"2023-02-04T00:00:00Z","UTCn12":2,"UTCn11":2,"UTCn10":2,"UTCn9":2,"UTCn8":2,"UTCn7":2,"UTCn6":2,"UTCn5":1,"UTCn4":1,"UTCn3":1,"UTCn2":1,"UTCn1":1,"UTC":1,"UTCp1":1,"UTCp2":1,"UTCp3":0,"UTCp4":3,"UTCp5":3,"UTCp6":3,"UTCp7":3,"UTCp8":3,"UTCp9":3,"UTCp10":3,"UTCp11":3,"UTCp12":3},{"ID":"20230203","CreatedOn":"2023-02-06T16:34:27.924094Z","Date":"2023-02-03T00:00:00Z","UTCn12":3,"UTCn11":3,"UTCn10":3,"UTCn9":3,"UTCn8":3,"UTCn7":3,"UTCn6":3,"UTCn5":3,"UTCn4":3,"UTCn3":3,"UTCn2":3,"UTCn1":3,"UTC":3,"UTCp1":3,"UTCp2":3,"UTCp3":3,"UTCp4":2,"UTCp5":2,"UTCp6":2,"UTCp7":2,"UTCp8":2,"UTCp9":2,"UTCp10":2,"UTCp11":2,"UTCp12":2},{"ID":"20230202","CreatedOn":"2023-02-06T16:34:23.40797Z","Date":"2023-02-02T00:00:00Z","UTCn12":2,"UTCn11":2,"UTCn10":2,"UTCn9":2,"UTCn8":2,"UTCn7":2,"UTCn6":2,"UTCn5":2,"UTCn4":2,"UTCn3":2,"UTCn2":2,"UTCn1":2,"UTC":2,"UTCp1":2,"UTCp2":2,"UTCp3":2,"UTCp4":0,"UTCp5":2,"UTCp6":5,"UTCp7":5,"UTCp8":5,"UTCp9":5,"UTCp10":5,"UTCp11":5,"UTCp12":5},{"ID":"20230201","CreatedOn":"2023-02-06T16:34:18.924319Z","Date":"2023-02-01T00:00:00Z","UTCn12":5,"UTCn11":5,"UTCn10":5,"UTCn9":5,"UTCn8":5,"UTCn7":5,"UTCn6":5,"UTCn5":5,"UTCn4":5,"UTCn3":5,"UTCn2":5,"UTCn1":5,"UTC":5,"UTCp1":5,"UTCp2":5,"UTCp3":5,"UTCp4":5,"UTCp5":3,"UTCp6":1,"UTCp7":4,"UTCp8":4,"UTCp9":4,"UTCp10":4,"UTCp11":4,"UTCp12":4},{"ID":"20230131","CreatedOn":"2023-02-06T16:34:14.716757Z","Date":"2023-01-31T00:00:00Z","UTCn12":4,"UTCn11":4,"UTCn10":4,"UTCn9":4,"UTCn8":4,"UTCn7":4,"UTCn6":4,"UTCn5":4,"UTCn4":4,"UTCn3":4,"UTCn2":4,"UTCn1":4,"UTC":4,"UTCp1":4,"UTCp2":4,"UTCp3":4,"UTCp4":4,"UTCp5":4,"UTCp6":3,"UTCp7":0,"UTCp8":0,"UTCp9":0,"UTCp10":0,"UTCp11":0,"UTCp12":0},{"ID":"20230130","CreatedOn":"2023-02-06T16:34:10.615737Z","Date":"2023-01-30T00:00:00Z","UTCn12":0,"UTCn11":0,"UTCn10":0,"UTCn9":0,"UTCn8":0,"UTCn7":0,"UTCn6":0,"UTCn5":0,"UTCn4":0,"UTCn3":0,"UTCn2":0,"UTCn1":0,"UTC":0,"UTCp1":0,"UTCp2":0,"UTCp3":0,"UTCp4":0,"UTCp5":0,"UTCp6":0,"UTCp7":0,"UTCp8":0,"UTCp9":0,"UTCp10":0,"UTCp11":0,"UTCp12":0},{"ID":"20230129","CreatedOn":"2023-02-06T15:58:20.453241Z","Date":"2023-01-29T00:00:00Z","UTCn12":0,"UTCn11":0,"UTCn10":0,"UTCn9":0,"UTCn8":0,"UTCn7":0,"UTCn6":0,"UTCn5":0,"UTCn4":0,"UTCn3":0,"UTCn2":0,"UTCn1":0,"UTC":0,"UTCp1":0,"UTCp2":0,"UTCp3":0,"UTCp4":0,"UTCp5":0,"UTCp6":0,"UTCp7":0,"UTCp8":0,"UTCp9":0,"UTCp10":0,"UTCp11":0,"UTCp12":0},{"ID":"20230128","CreatedOn":"2023-02-06T15:58:17.240953Z","Date":"2023-01-28T00:00:00Z","UTCn12":0,"UTCn11":0,"UTCn10":0,"UTCn9":0,"UTCn8":0,"UTCn7":0,"UTCn6":0,"UTCn5":0,"UTCn4":0,"UTCn3":0,"UTCn2":0,"UTCn1":0,"UTC":0,"UTCp1":0,"UTCp2":0,"UTCp3":0,"UTCp4":0,"UTCp5":0,"UTCp6":0,"UTCp7":0,"UTCp8":0,"UTCp9":0,"UTCp10":0,"UTCp11":0,"UTCp12":0},{"ID":"20230127","CreatedOn":"2023-02-06T15:58:14.011052Z","Date":"2023-01-27T00:00:00Z","UTCn12":0,"UTCn11":0,"UTCn10":0,"UTCn9":0,"UTCn8":0,"UTCn7":0,"UTCn6":0,"UTCn5":0,"UTCn4":0,"UTCn3":0,"UTCn2":0,"UTCn1":0,"UTC":0,"UTCp1":0,"UTCp2":0,"UTCp3":0,"UTCp4":0,"UTCp5":0,"UTCp6":0,"UTCp7":0,"UTCp8":0,"UTCp9":0,"UTCp10":0,"UTCp11":0,"UTCp12":0},{"ID":"20230126","CreatedOn":"2023-02-06T15:58:10.590811Z","Date":"2023-01-26T00:00:00Z","UTCn12":0,"UTCn11":0,"UTCn10":0,"UTCn9":0,"UTCn8":0,"UTCn7":0,"UTCn6":0,"UTCn5":0,"UTCn4":0,"UTCn3":0,"UTCn2":0,"UTCn1":0,"UTC":0,"UTCp1":0,"UTCp2":0,"UTCp3":0,"UTCp4":0,"UTCp5":0,"UTCp6":0,"UTCp7":0,"UTCp8":0,"UTCp9":0,"UTCp10":0,"UTCp11":0,"UTCp12":0},{"ID":"20230125","CreatedOn":"2023-02-06T15:58:07.148966Z","Date":"2023-01-25T00:00:00Z","UTCn12":0,"UTCn11":0,"UTCn10":0,"UTCn9":0,"UTCn8":0,"UTCn7":0,"UTCn6":0,"UTCn5":0,"UTCn4":0,"UTCn3":0,"UTCn2":0,"UTCn1":0,"UTC":0,"UTCp1":0,"UTCp2":0,"UTCp3":0,"UTCp4":0,"UTCp5":0,"UTCp6":0,"UTCp7":0,"UTCp8":0,"UTCp9":0,"UTCp10":0,"UTCp11":0,"UTCp12":0}]}
          />
        )
      },
    );
    widgets.push(
      {
        Type: "SignatureCompletions",
        Content: (
          <SignatureCompletionsWidget
            {...getCoreWidgetProps()}
            samples={[{"ID":"20230206","CreatedOn":"2023-02-06T18:59:57.040861Z","Date":"2023-02-06T00:00:00Z","UTCn12":0,"UTCn11":0,"UTCn10":0,"UTCn9":0,"UTCn8":0,"UTCn7":0,"UTCn6":0,"UTCn5":1,"UTCn4":1,"UTCn3":1,"UTCn2":1,"UTCn1":1,"UTC":1,"UTCp1":1,"UTCp2":1,"UTCp3":1,"UTCp4":1,"UTCp5":1,"UTCp6":1,"UTCp7":1,"UTCp8":1,"UTCp9":1,"UTCp10":1,"UTCp11":1,"UTCp12":1},{"ID":"20230205","CreatedOn":"2023-02-06T18:59:53.187429Z","Date":"2023-02-05T00:00:00Z","UTCn12":1,"UTCn11":1,"UTCn10":1,"UTCn9":1,"UTCn8":1,"UTCn7":1,"UTCn6":1,"UTCn5":0,"UTCn4":0,"UTCn3":0,"UTCn2":0,"UTCn1":0,"UTC":0,"UTCp1":0,"UTCp2":1,"UTCp3":1,"UTCp4":1,"UTCp5":1,"UTCp6":1,"UTCp7":1,"UTCp8":1,"UTCp9":1,"UTCp10":1,"UTCp11":1,"UTCp12":1},{"ID":"20230204","CreatedOn":"2023-02-06T18:59:49.230288Z","Date":"2023-02-04T00:00:00Z","UTCn12":1,"UTCn11":1,"UTCn10":1,"UTCn9":1,"UTCn8":1,"UTCn7":1,"UTCn6":1,"UTCn5":1,"UTCn4":1,"UTCn3":1,"UTCn2":1,"UTCn1":1,"UTC":2,"UTCp1":2,"UTCp2":1,"UTCp3":1,"UTCp4":2,"UTCp5":2,"UTCp6":2,"UTCp7":2,"UTCp8":2,"UTCp9":2,"UTCp10":2,"UTCp11":2,"UTCp12":2},{"ID":"20230203","CreatedOn":"2023-02-06T18:59:44.894499Z","Date":"2023-02-03T00:00:00Z","UTCn12":2,"UTCn11":2,"UTCn10":2,"UTCn9":2,"UTCn8":2,"UTCn7":2,"UTCn6":2,"UTCn5":2,"UTCn4":2,"UTCn3":2,"UTCn2":2,"UTCn1":2,"UTC":1,"UTCp1":1,"UTCp2":1,"UTCp3":1,"UTCp4":0,"UTCp5":0,"UTCp6":0,"UTCp7":0,"UTCp8":0,"UTCp9":0,"UTCp10":0,"UTCp11":0,"UTCp12":0},{"ID":"20230202","CreatedOn":"2023-02-06T18:59:41.24364Z","Date":"2023-02-02T00:00:00Z","UTCn12":0,"UTCn11":0,"UTCn10":0,"UTCn9":0,"UTCn8":0,"UTCn7":0,"UTCn6":0,"UTCn5":0,"UTCn4":0,"UTCn3":0,"UTCn2":0,"UTCn1":0,"UTC":0,"UTCp1":0,"UTCp2":0,"UTCp3":0,"UTCp4":0,"UTCp5":0,"UTCp6":0,"UTCp7":0,"UTCp8":0,"UTCp9":0,"UTCp10":0,"UTCp11":0,"UTCp12":0},{"ID":"20230201","CreatedOn":"2023-02-06T18:59:38.238285Z","Date":"2023-02-01T00:00:00Z","UTCn12":0,"UTCn11":0,"UTCn10":0,"UTCn9":0,"UTCn8":0,"UTCn7":0,"UTCn6":0,"UTCn5":0,"UTCn4":0,"UTCn3":0,"UTCn2":0,"UTCn1":0,"UTC":1,"UTCp1":1,"UTCp2":1,"UTCp3":1,"UTCp4":1,"UTCp5":1,"UTCp6":1,"UTCp7":1,"UTCp8":1,"UTCp9":1,"UTCp10":1,"UTCp11":1,"UTCp12":1},{"ID":"20230131","CreatedOn":"2023-02-06T18:59:34.279817Z","Date":"2023-01-31T00:00:00Z","UTCn12":1,"UTCn11":1,"UTCn10":1,"UTCn9":1,"UTCn8":1,"UTCn7":1,"UTCn6":1,"UTCn5":1,"UTCn4":1,"UTCn3":1,"UTCn2":1,"UTCn1":1,"UTC":0,"UTCp1":0,"UTCp2":0,"UTCp3":0,"UTCp4":0,"UTCp5":0,"UTCp6":0,"UTCp7":0,"UTCp8":0,"UTCp9":0,"UTCp10":0,"UTCp11":0,"UTCp12":0},{"ID":"20230130","CreatedOn":"2023-02-06T18:59:29.923932Z","Date":"2023-01-30T00:00:00Z","UTCn12":0,"UTCn11":0,"UTCn10":0,"UTCn9":0,"UTCn8":0,"UTCn7":0,"UTCn6":0,"UTCn5":0,"UTCn4":0,"UTCn3":0,"UTCn2":0,"UTCn1":0,"UTC":0,"UTCp1":0,"UTCp2":0,"UTCp3":0,"UTCp4":0,"UTCp5":0,"UTCp6":0,"UTCp7":0,"UTCp8":0,"UTCp9":0,"UTCp10":0,"UTCp11":0,"UTCp12":0}]}
          />
        )
      },
    );
    widgets.push(
      {
        Type: "SignatureSessions",
        Content: (
          <SignatureSessionsWidget
            {...getCoreWidgetProps()}
            samples={[
              { Complete: 10, Pending: 15, Canceled: 2, CreatedOn: sampleDateBase-(8*14400000), },
              { Complete: 11, Pending: 14, Canceled: 2, CreatedOn: sampleDateBase-(7*14400000), },
              { Complete: 11, Pending: 14, Canceled: 2, CreatedOn: sampleDateBase-(6*14400000), },
              { Complete: 11, Pending: 14, Canceled: 2, CreatedOn: sampleDateBase-(5*14400000), },
              { Complete: 9, Pending: 14, Canceled: 2, CreatedOn: sampleDateBase-(4*14400000), },
              { Complete: 8, Pending: 14, Canceled: 3, CreatedOn: sampleDateBase-(3*14400000), },
              { Complete: 6, Pending: 14, Canceled: 3, CreatedOn: sampleDateBase-(2*14400000), },
              { Complete: 6, Pending: 14, Canceled: 3, CreatedOn: sampleDateBase-(1*14400000), },
            ]}
          />
        )
      },
    );
    // widgets.push(
    //   {
    //     Type: "Documents",
    //     Content: (
    //       <DocumentsWidget
    //         {...getCoreWidgetProps()}
    //         samples={[
    //           { Name: "Expense Report - June", CreatedOn: sampleDateBase-(1*86400000), },
    //           { Name: "Meeting Notes", CreatedOn: sampleDateBase-(2*86400000), },
    //           { Name: "Employee Handbook", CreatedOn: sampleDateBase-(3*86400000), },
    //           { Name: "Quarterly Report", CreatedOn: sampleDateBase-(3*86400000), },
    //           { Name: "July - Inventory", CreatedOn: sampleDateBase-(3*86400000), },
    //           { Name: "June - Inventory", CreatedOn: sampleDateBase-(4*86400000), },
    //         ]}
    //       />
    //     )
    //   },
    // );
    // if (!ActiveOrganizationPermissions.IsReadOnly) {
    //   widgets.push(
    //     { Type: "Capture",
    //       Content: (
    //         <CaptureWidget
    //           history={this.props.history}
    //           noPointerEvents
    //           noMargin
    //           onApiError={err => this.handleApiError(err)}
    //           onAlert={details => this.handleAlert(details)}
    //           // DashboardWidget={widget}
    //         />
    //       )
    //     },
    //     { Type: "Inbox",
    //       Content: (
    //         <InboxWidget
    //           history={this.props.history}
    //           noPointerEvents
    //           noMargin
    //           onApiError={err => this.handleApiError(err)}
    //           onAlert={details => this.handleAlert(details)}
    //           SampleData={{
    //             Documents: [
    //               { ID: "03", Name: "Invoice 67890.pdf", CreatedOn: "2021-03-14 14:24:20" },
    //               { ID: "02", Name: "Invoice 12386.pdf", CreatedOn: "2021-03-14 13:59:50" },
    //               { ID: "01", Name: "Invoice 12345.pdf", CreatedOn: "2021-03-14 13:14:15" },
    //             ],
    //             InboxCount: 87,
    //           }}
    //         />
    //       )
    //     },
    //     { Type: "Approvals",
    //       Content: (
    //         <ApprovalsWidget
    //           history={this.props.history}
    //           noPointerEvents
    //           noMargin
    //           onApiError={err => this.handleApiError(err)}
    //           onAlert={details => this.handleAlert(details)}
    //           SampleData={{
    //             Approvals: [
    //               { ID: "03", ItemName: "Purchase Order 890.pdf", CreatedOn: "2021-04-22 16:14:00" },
    //               { ID: "02", ItemName: "Purchase Order 70129.pdf", CreatedOn: "2021-04-21 12:10:10" },
    //               { ID: "01", ItemName: "Purchase Order 4456.pdf", CreatedOn: "2021-04-14 09:44:30" },
    //             ],
    //           }}
    //         />
    //       )
    //     },
    //     { Type: "Tasks",
    //       Content: (
    //         <TasksWidget
    //           history={this.props.history}
    //           noPointerEvents
    //           noMargin
    //           onApiError={err => this.handleApiError(err)}
    //           onAlert={details => this.handleAlert(details)}
    //           SampleData={{
    //             Tasks: [
    //               { ID: "03", Name: "HR Interview", CreatedOn: "2021-03-01 09:21:00" },
    //               { ID: "02", Name: "Form Completion", CreatedOn: "2021-03-02 10:22:10" },
    //               { ID: "01", Name: "Follow-up Call", CreatedOn: "2021-03-03 11:30:30" },
    //             ],
    //           }}
    //         />
    //       )
    //     },
    //   );
    // }
    // widgets.push(
    //   { Type: "Folder",
    //     Content: (
    //       <FolderWidget
    //         history={this.props.history}
    //         noPointerEvents
    //         noMargin
    //         onApiError={err => this.handleApiError(err)}
    //         onAlert={details => this.handleAlert(details)}
    //         DashboardWidget={{Name: "ABC Company, Inc."}}
    //       />
    //     )
    //   },
    //   { Type: "PowerSearch",
    //     Content: (
    //       <PowerSearchWidget
    //         history={this.props.history}
    //         noPointerEvents
    //         noMargin
    //         onApiError={err => this.handleApiError(err)}
    //         onAlert={details => this.handleAlert(details)}
    //         DashboardWidget={{Name: "ABC Invoices"}}
    //       />
    //     )
    //   },
    //   { Type: "Subscriptions",
    //     Content: (
    //       <SubscriptionsWidget
    //         history={this.props.history}
    //         noPointerEvents
    //         noMargin
    //         onApiError={err => this.handleApiError(err)}
    //         onAlert={details => this.handleAlert(details)}
    //         SampleData={{
    //           DocumentSubscriptions: [
    //             { ID: "03", DocumentName: "Sales Order 6810.pdf", CreatedOn: "2021-05-01 16:14:00" },
    //             { ID: "02", DocumentName: "Sales Order 5981.pdf", CreatedOn: "2021-05-02 12:10:10" },
    //             { ID: "01", DocumentName: "Sales Order 5855.pdf", CreatedOn: "2021-05-03 09:44:30" },
    //           ],
    //         }}
    //       />
    //     )
    //   },
    // );
    // widgets.push(
    //   { Type: "NeedSignature",
    //     Content: (
    //       <NeedSignatureWidget
    //         history={this.props.history}
    //         noPointerEvents
    //         noMargin
    //         onApiError={err => this.handleApiError(err)}
    //         onAlert={details => this.handleAlert(details)}
    //         SampleData={{
    //           DocumentSignatureSessionRecipients: [
    //             { ID: "02", DocumentName: "Contract 1173A.pdf", RequestedOn: "2021-06-14 16:22:05" },
    //             { ID: "01", DocumentName: "Agreement 2021-07-01.pdf", RequestedOn: "2021-07-02 12:22:05" },
    //           ],
    //         }}
    //       />
    //     )
    //   },
    // );
    // if (!ActiveOrganizationPermissions.IsReadOnly) {
    //   widgets.push(
    //     { Type: "NeedSignatureAdmin",
    //       Content: (
    //         <NeedSignatureWidget
    //           history={this.props.history}
    //           noPointerEvents
    //           noMargin
    //           isAdmin
    //           onApiError={err => this.handleApiError(err)}
    //           onAlert={details => this.handleAlert(details)}
    //           SampleData={{
    //             DocumentSignatureSessionRecipients: [
    //               { ID: "02", DocumentName: "Sales Contract 2/26.pdf", RequestedOn: "2021-07-01 16:56:22" },
    //               { ID: "01", DocumentName: "Contract 1173A.pdf", RequestedOn: "2021-07-02 12:22:05" },
    //             ],
    //           }}
    //         />
    //       )
    //     },
    //   );
    // }

    const gridItems = widgets.map(w => {
      // let isSelected = (SelectedWidgetType === w.Type);
      // let checkbox = (isSelected)
      //   ? (
      //     <Checkbox checked className={classes.checkbox} disableRipple
      //       checkedIcon={<CheckBoxIcon fontSize="large" style={{fontSize:48}} />} />  
      //   ) : null;
      return (
        <Grid item key={w.Type}
          onClick={() => this.handleSelectWidget(w)}
          // style={{opacity: (!SelectedWidgetType || isSelected) ? 1 : 0.5}}
          xs={12} sm={6} className={classes.gridItem}>
          {w.Content}
          {/* {checkbox} */}
        </Grid>
      );
    });

    const noWidgetsGridItem = (!gridItems.length)
      ? (
        <Grid item xs={12} style={{textAlign:"center",marginTop:48}}>
          <Typography variant="h6">
            You have all the widgets!
          </Typography>
        </Grid>
      ) : null;

    const projectSelectionDialog = (ShowProjectSelectionDialog)
      ? GetProjectSelectionDialog(
        this.context,
        null,
        this.state,
        state => this.setState(state),
        projectMember => this.handleAddDashboardWidget({
          ...DashboardWidget,
          ProjectMemberID: projectMember.ID,
          ProjectID: projectMember.ProjectID,
          ProjectName: projectMember.ProjectName,
          ProjectAccess: projectMember.ProjectAccess,
          Type: SelectedWidgetType,
        }),
      ) : null;

    return (
      <Dialog
        classes={{
          paper:classes.dialogPaper,
        }}
        fullWidth={!IsMobile()}
        fullScreen={IsMobile()}
        maxWidth="md"
        TransitionComponent={Transition}
        open={open}
        onClose={this.handleClose}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description">
        <DialogTitle id="dialog-title" className={classes.content}>
          <span>Dashboard Widgets</span>
        </DialogTitle>
        <DialogContent className={classes.content}>
          {progressIndicator}
          <MultiUseDialog Details={DialogDetails} />
          {projectSelectionDialog}

          <Grid container spacing={2} className={classes.contentGrid}>

            {gridItems}
            {noWidgetsGridItem}

          </Grid>        
        </DialogContent>
        {dialogActions}
      </Dialog>
    );
  }
}

AddDashboardWidgetDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  activeDashboardWidgets: PropTypes.array.isRequired,
  organizationId: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  onApiError: PropTypes.func.isRequired,
};

export default withStyles(styles, {withTheme: true})(AddDashboardWidgetDialog);